import React from 'react';
import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { tasksTypeOnly, TASKS_FONT } from './tasksTheme';

/**
 * Wrap a page in this and it keeps its own colours and layout but reads like
 * Tasks: Inter, 14px, normal weight with medium for emphasis.
 */
const TasksType: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ThemeProvider theme={tasksTypeOnly}>
    <Box sx={{ display: 'contents', fontFamily: TASKS_FONT, fontSize: 14, '& b, & strong': { fontWeight: 500 } }}>
      {children}
    </Box>
  </ThemeProvider>
);

export default TasksType;
